import { RootState } from 'app'

export const getDisplayModels = (state: RootState) =>
  state.common.displayModels.displayModels
